import GlobalHelper from './GlobalHelper';

let NovedadesHelper = function () {
    function setearCamposNovedad(novedadMap, NovedadCampoId, NovedadCampoCodigo, novedad) {
        novedadMap.NovedadCampoId = NovedadCampoId;
        novedadMap.NovedadCampoCodigo = NovedadCampoCodigo;
        novedadMap.ValorAnterior = novedad.ValorAnterior;
        novedadMap.ValorNovedad = novedad.ValorNovedad;
    }

    /**
     * Mapea las novedades
     * @param {any} novedad
     */
    function mapearNovedad(novedad) {
        let novedadMap = {
            'Id': novedad.id <= 0 ? null : novedad.id,
            'NovedadTipoId': novedad.NovedadTipoId
        }

        switch (novedad.NovedadTipoId) {
            case 3:
                setearCamposNovedad(novedadMap, null, "LIMCO_EMPR", novedad);
                break;
            case 1:
                setearCamposNovedad(novedadMap, null, "LIMCO_CUEN", novedad);
                break;
            case 2:
                setearCamposNovedad(novedadMap, null, "LIMCO_TARJ", novedad);
                break;
            default:
                break;
        }

        return novedadMap;
    }

    /**
     * Genera las novededades
     * @param {any} novedades
     */
    function _generarNovedades(novedades) {
        let list = [];
        for (var j = 0; j < novedades.length; j++) {
            list.push(mapearNovedad(novedades[j]));
        }
        return list;
    }

    ///////////////////////////////////////////////////////////////////////////////////////////
    //Componentes que reciben los datos del objeto junto con su novedad y lo devuelve resuelto
    ///////////////////////////////////////////////////////////////////////////////////////////
    /**
     * Transforma los datos del objeto junto con su novedad y lo devuelve resuelto para componente DATA PICKER
     * @param {any} campoCodigo ej: "VIGPL_EMPR"
     * @param {any} valor variable obtenida de la tabla EMPRESA, CUENTA ó TARJETA 
     * @param {any} novedad objeto obtenido de la tabla NOVEDAD
     * @param {any} esNovedadEditada array de objetos 'campoCodigo' perteneciente a la pantalla
     */
    function _datePickerConNovedad(campoCodigo, valor, novedad, esNovedadEditada) {
        let fecha = undefined;
        let fechaFormato = undefined;
        let novedadFecha = undefined;
        if (novedad != undefined) {
            novedadFecha = novedad.find(x => x.NovedadCampoCodigo == campoCodigo);
            if (novedadFecha != undefined) {
                let esNovedadEditadaCampo = esNovedadEditada.find(x => x.campoCodigo == campoCodigo).editado;
                if (esNovedadEditadaCampo) {
                    fecha = valor;
                    if (fecha != null && fecha != "") {
                        fechaFormato = defaultText = GlobalHelper.FormatDate(fecha);
                    } else {
                        defaultText = "Seleccione una fecha";
                        fechaFormato = GlobalHelper.FormatDate(new Date().toISOString().slice(0, 19).replace('T', ' '));
                    }
                }
                else {
                    fecha = novedadFecha.ValorNovedad;
                    if (fecha != null && fecha != "") {
                        fechaFormato = defaultText = GlobalHelper.FormatDate(fecha);
                    } else {
                        defaultText = "Seleccione una fecha";
                        fechaFormato = GlobalHelper.FormatDate(new Date().toISOString().slice(0, 19).replace('T', ' '));
                    }
                }
            }
            else {
                fecha = valor;
                if (fecha != null && fecha != "") {
                    fechaFormato = defaultText = GlobalHelper.FormatDate(fecha);
                } else {
                    defaultText = "Seleccione una fecha";
                    fechaFormato = GlobalHelper.FormatDate(new Date().toISOString().slice(0, 19).replace('T', ' '));
                }
            }
        } else {
            fecha = valor;
            if (fecha != null && fecha != "") {
                fechaFormato = defaultText = GlobalHelper.FormatDate(fecha);
            } else {
                defaultText = "Seleccione una fecha";
                fechaFormato = GlobalHelper.FormatDate(new Date().toISOString().slice(0, 19).replace('T', ' '));
            }
        }

        return {
            fecha, fechaFormato, novedadFecha, defaultText
        };
    }

    /**
    * Transforma los datos del objeto junto con su novedad y lo devuelve resuelto para componente CHECK
    * @param {any} campoCodigo ej: "VIGPL_EMPR"
    * @param {any} valor variable obtenida de la tabla EMPRESA, CUENTA ó TARJETA
    * @param {any} novedad objeto obtenido de la tabla NOVEDAD
    * @param {any} esNovedadEditada array de objetos 'campoCodigo' perteneciente a la pantalla
    * @param {any} texto texto correspondiente a componente como descripcion
    */
    function _checkConNovedad(campoCodigo, valor, novedad, esNovedadEditada, texto) {
        let check = undefined;
        let novedadCheck = undefined;
        let descripcion = texto;
        if (novedad != undefined) {
            novedadCheck = novedad.find(x => x.NovedadCampoCodigo == campoCodigo);
            if (novedadCheck != undefined) {
                novedadCheck.ValorAnterior = novedadCheck.ValorAnterior == "NO" ? "0" : novedadCheck.ValorAnterior == "SI" ? "1" : novedadCheck.ValorAnterior
                let esNovedadEditadaCampo = esNovedadEditada.find(x => x.campoCodigo == campoCodigo).editado;
                if (esNovedadEditadaCampo) {
                    check = valor != undefined ? valor : false
                    novedadCheck.ValorAnterior = novedadCheck.ValorAnterior == "0" ? "NO" : novedadCheck.ValorAnterior == "1" ? "SI" : "NO"
                    descripcion = novedadCheck.ValorNovedad == "0" ? "NO " + descripcion : novedadCheck.ValorNovedad == "1" ? "√ " + descripcion : "NO " + descripcion
                }
                else {
                    check = novedadCheck.ValorNovedad == "0" ? false : novedadCheck.ValorNovedad == "1" ? true : false
                    novedadCheck.ValorAnterior = novedadCheck.ValorAnterior == "0" ? "NO" : novedadCheck.ValorAnterior == "1" ? "SI" : "NO"
                    descripcion = novedadCheck.ValorNovedad == "0" ? "NO " + descripcion : novedadCheck.ValorNovedad == "1" ? "√ " + descripcion : "NO " + descripcion
                }

            } else {
                check = valor != undefined ? valor : false
                descripcion = check == false ? "NO " + descripcion : "√ " + descripcion
            }
        } else {
            check = valor != undefined ? valor : false
            descripcion = check == false ? "NO " + descripcion : "√ " + descripcion
        }

        return {
            check, descripcion, novedadCheck
        };
    }

    /**
    * Transforma los datos del objeto junto con su novedad y lo devuelve resuelto para componente SELECT COMBO
    * @param {any} campoCodigo ej: "VIGPL_EMPR"
    * @param {any} valor varible obtenida de la tabla EMPRESA, CUENTA ó TARJETA
    * @param {any} novedad objeto obtenido de la tabla NOVEDAD
    * @param {any} esNovedadEditada array de objetos 'campoCodigo' perteneciente a la pantalla
    * @param {any} atlasParametria array de objetos de tablas ATLAS... para parametría
    */
    function _selectComboConNovedad(campoCodigo, valor, novedad, esNovedadEditada, atlasParametria) {
        let selectComboId = undefined;
        let selectComboDescripcion = undefined;
        let novedadSelectCombo = undefined;
        let parametria = undefined;

        parametria = atlasParametria.find(x => x.Id == valor);
        if (parametria) {
            selectComboId = parametria.Id;
            selectComboDescripcion = parametria.Descripcion;
        } 
        if (novedad) {
            novedadSelectCombo = novedad.find(x => x.NovedadCampoCodigo == campoCodigo);

            if (novedadSelectCombo) {
                let parametriaValorAnterior = atlasParametria.find(x => x.Id == novedadSelectCombo.ValorAnterior);
                novedadSelectCombo.ValorAnteriorFormateado = (parametriaValorAnterior) ? parametriaValorAnterior.Descripcion : "";
                let esNovedadEditadaCampo = esNovedadEditada.find(x => x.campoCodigo == campoCodigo).editado;

                if (esNovedadEditadaCampo) {
                    parametria = atlasParametria.find(x => x.Id == novedadSelectCombo.ValorAnterior);
                    novedadSelectCombo.ValorAnterior = parametria ? parametria.Id : novedadSelectCombo.ValorAnterior;
                }
                else {
                    selectComboId = novedadSelectCombo.ValorNovedad;
                    parametria = atlasParametria.find(x => x.Id == novedadSelectCombo.ValorNovedad);

                    selectComboDescripcion = (parametria || {}).Descripcion;
                }
            }
        }

        return {
            selectComboId, selectComboDescripcion, novedadSelectCombo
        };
    }
    /**
    * Transforma los datos del objeto junto con su novedad y lo devuelve resuelto para componente INPUT
    * @param {any} campoCodigo ej: "VIGPL_EMPR"
    * @param {any} valor varible obtenida de la tabla EMPRESA, CUENTA ó TARJETA
    * @param {any} novedad objeto obtenido de la tabla NOVEDAD
    * @param {any} esNovedadEditada array de objetos 'campoCodigo' perteneciente a la pantalla
    */
    function _inputConNovedad(campoCodigo, valor, novedad, esNovedadEditada) {
        let descripcion = undefined;
        let novedadInput = undefined;
        if (novedad != undefined) {
            novedadInput = novedad.find(x => x.NovedadCampoCodigo == campoCodigo);
            if (novedadInput != undefined) {
                let esNovedadEditadaCampo = esNovedadEditada.find(x => x.campoCodigo == campoCodigo).editado;
                if (esNovedadEditadaCampo) {
                    descripcion = valor;
                }
                else {
                    descripcion = novedadInput.ValorNovedad;
                }
            }
            else {
                descripcion = valor;
            }
        } else {
            descripcion = valor;
        }

        return {
            descripcion, novedadInput
        };
    }

    /**
     * Valida las novedades para determinados campos
     * @param {any} novedades objeto obtenido de la tabla NOVEDAD
     * @param {any} campos parametro array que contiene la Clave y Valor del objecto a buscar en las novedades
     */
    function _validarNovedadesPorCampos(novedades, campos) {
        /*Realiza validaciones dinamicamente segun los campos enviados por parametro*/
        let validaciones = [];
        campos = (campos) ? campos : [];

        let result = novedades.filter((nov) => {
            validaciones = [];

            campos.forEach((param) => {
                validaciones.push(nov[param.Clave] == param.Valor);
            });

            return !validaciones.some((validacion) => { return validacion == false });
        });

        return result;
    }

    /**
    * Transforma los datos del objeto junto con su novedad y lo devuelve resuelto para componente LIMITE
    * @param {any} campoCodigo ej: "VIGPL_EMPR"
    * @param {any} valor varible obtenida de la tabla EMPRESA, CUENTA ó TARJETA
    * @param {any} novedad objeto obtenido de la tabla NOVEDAD
    * @param {any} esNovedadEditada array de objetos 'campoCodigo' perteneciente a la pantalla
    */
    function _limiteConNovedad(campoCodigo, valor, novedad, esNovedadEditada) {
        let limite, limiteFormato = undefined;
        let novedadLimite = undefined;
        if (novedad != undefined) {
            novedadLimite = novedad.find(x => x.NovedadCampoCodigo == campoCodigo);
            if (novedadLimite != undefined) {
                let esNovedadEditadaCampo = esNovedadEditada.find(x => x.campoCodigo == campoCodigo).editado;
                if (esNovedadEditadaCampo) {
                    limite = valor;
                    limiteFormato = GlobalHelper.ConvertirNumeroMilesMillones(valor);
                }
                else {
                    limite = novedadLimite.ValorNovedad;
                    limiteFormato = GlobalHelper.ConvertirNumeroMilesMillones(novedadLimite.ValorNovedad);
                }
            }
            else {
                limite = valor;
                limiteFormato = GlobalHelper.ConvertirNumeroMilesMillones(valor);
            }
        } else {
            limite = valor;
            limiteFormato = GlobalHelper.ConvertirNumeroMilesMillones(valor);
        }

        return {
            limite, limiteFormato, novedadLimite
        };
    }

    /**
    * Transforma los datos del objeto junto con su novedad y lo devuelve resuelto para componente DOMICILIO
    * @param {any} campoCodigo ej: "VIGPL_EMPR"
    * @param {any} valor varible obtenida de la tabla EMPRESA, CUENTA ó TARJETA
    * @param {any} novedad objeto obtenido de la tabla NOVEDAD
    * @param {any} esNovedadEditada array de objetos 'campoCodigo' perteneciente a la pantalla
    */
    function _domicilioConNovedad(campoCodigo, valor, novedad, esNovedadEditada) {

        //TODO: Completar, realizar una tarea

        return {
            fecha, fechaFormato, novedad, defaultText
        };
    }
    ///////////////////////////////////////////////////////////////////////////////////////////

    function _asignarDescripcionPorId(opciones,id){
        let descripcion = "";
        opciones && id && opciones.map(opcion=>{
            if(opcion.Id == id || opcion.ID == id){
                if(opcion.Descripcion) descripcion = opcion.Descripcion;
                if(opcion.DESCRIPCION) descripcion = opcion.DESCRIPCION;
            }
        })
        
        return descripcion;
    }

    return {
        GenerarNovedades: function (novedades) {
            return _generarNovedades(novedades);
        },
        AsignarDescripcionPorId: function (opciones,id) {
            return _asignarDescripcionPorId(opciones,id);
        },

        //ej: NovedadeslHelper.DatePickerConNovedad("FETOP_EMPR", this.props.data.empresaDatos.FechaTopeAgro, this.props.data.novedadesEmpresaDatos, this.props.data.esNovedadEditada);
        DatePickerConNovedad: function (campoCodigo, valor, novedad, esNovedadEditada) {
            return _datePickerConNovedad(campoCodigo, valor, novedad, esNovedadEditada);
        },

        //ej: NovedadeslHelper.CheckConNovedad("PERAD_EMPR", this.props.data.empresaDatos.PermiteAdelantos, this.props.data.novedadesEmpresaDatos, this.props.data.esNovedadEditada, "Permite Cuotas");
        CheckConNovedad: function (campoCodigo, valor, novedad, esNovedadEditada, texto) {
            return _checkConNovedad(campoCodigo, valor, novedad, esNovedadEditada, texto);
        },

        //ej: NovedadeslHelper.SelectComboConNovedad("BONRE_EMPR", porcentajeCodigoBonificacion, this.props.data.novedadesEmpresaDatos, this.props.data.esNovedadEditada, this.props.data.atlasBonificacionRenovacion);
        SelectComboConNovedad: function (campoCodigo, valor, novedad, esNovedadEditada, atlasParametria) {
            return _selectComboConNovedad(campoCodigo, valor, novedad, esNovedadEditada, atlasParametria);
        },

        //ej: NovedadeslHelper.SelectComboConNovedad("BONRE_EMPR", porcentajeCodigoBonificacion, this.props.data.novedadesEmpresaDatos, this.props.data.esNovedadEditada, this.props.data.atlasBonificacionRenovacion, [{Clave:"TarjetaCreditoId", Valor:"1"}]);
        SelectComboConNovedadPorCampos: function (campoCodigo, valor, novedad, esNovedadEditada, atlasParametria, campos) {
            let novedades = _validarNovedadesPorCampos(novedad, campos);
            return _selectComboConNovedad(campoCodigo, valor, novedades, esNovedadEditada, atlasParametria);
        },

        //ej: NovedadeslHelper.InputConNovedad("DESCR_EMPR", this.props.data.empresaDatos.Descripcion, this.props.data.novedadesEmpresaDatos, this.props.data.esNovedadEditada);
        InputConNovedad: function (campoCodigo, valor, novedad, esNovedadEditada) {
            return _inputConNovedad(campoCodigo, valor, novedad, esNovedadEditada);
        },
        //ej: NovedadeslHelper.InputConNovedad("DESCR_EMPR", this.props.data.empresaDatos.Descripcion, this.props.data.novedadesEmpresaDatos, this.props.data.esNovedadEditada, [{Clave:"TarjetaCreditoId", Valor:"1"}]);
        InputConNovedadPorCampos: function (campoCodigo, valor, novedad, esNovedadEditada, campos) {
            let novedades = _validarNovedadesPorCampos(novedad, campos);
            return _inputConNovedad(campoCodigo, valor, novedades, esNovedadEditada);
        },

        CheckConNovedadPorCampos: function (campoCodigo, valor, novedad, esNovedadEditada, texto, campos) {
            let novedades = _validarNovedadesPorCampos(novedad, campos);
            return _checkConNovedad(campoCodigo, valor, novedades, esNovedadEditada, texto);
        },

        //ej: NovedadeslHelper.LimiteConNovedad("LIMCO_EMPR", this.props.data.empresaDatos.LimiteCompra, this.props.data.novedadesEmpresaDatos, this.props.data.esNovedadEditada);
        LimiteConNovedad: function (campoCodigo, valor, novedad, esNovedadEditada) {
            return _limiteConNovedad(campoCodigo, valor, novedad, esNovedadEditada);
        },

        //ej: 
        DomicilioConNovedad: function (campoCodigo, valor, novedad, esNovedadEditada) {
            return _domicilioConNovedad(campoCodigo, valor, novedad, esNovedadEditada);
        }
    }
}

let novedadesHelper = new NovedadesHelper();
export default novedadesHelper;